module.exports = __webpack_public_path__ + "media/images/plans/photo_studio/photo7-5-2821759f5c3ec79477b51f94add3837d.png";